var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoProfilePicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2553 36.2072C33.2553 36.6848 32.8588 37.0734 32.3715 37.0734H2.62837C2.14125 37.0734 1.74473 36.6848 1.74473 36.2072V36.1356C1.74473 28.6285 7.9751 22.5212 15.6331 22.5212H19.3668C27.0249 22.5212 33.2553 28.6285 33.2553 36.1356V36.2072ZM15.6331 20.8108C7.01313 20.8108 0 27.6855 0 36.1356V36.2072C0 37.628 1.1791 38.7838 2.62837 38.7838H32.3715C33.8208 38.7838 35 37.628 35 36.2072V36.1356C35 27.6855 27.987 20.8108 19.3668 20.8108H15.6331Z",
    fill: "#D0D8E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0268 1.74695C21.2794 1.74695 24.7393 5.20679 24.7393 9.45937C24.7393 13.7121 21.2794 17.172 17.0268 17.172C12.7741 17.172 9.31442 13.7121 9.31442 9.45937C9.31442 5.20679 12.7741 1.74695 17.0268 1.74695M17.0268 18.9189C22.2429 18.9189 26.4863 14.6754 26.4863 9.45937C26.4863 4.2435 22.2429 0 17.0268 0C11.8108 0 7.56738 4.2435 7.56738 9.45937C7.56738 14.6754 11.8108 18.9189 17.0268 18.9189",
    fill: "#D0D8E3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfilePicture);
export default __webpack_public_path__ + "static/media/no_profile_picture.e342f3a5.svg";
export { ForwardRef as ReactComponent };